import React, {useEffect, useState} from 'react';
import './Home.css';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Container from "@mui/material/Container";
import ProductCard from "../products/productCard/ProductCard";
import {CardContent, CircularProgress} from "@mui/material";
import RightArrow from "../../components/carrouselArrows/RightArrow";
import LeftArrow from "../../components/carrouselArrows/LeftArrow";
import app from "../../firebaseConfig/firebaseConfig";
import {getDatabase, onValue, ref} from "firebase/database";
import ProductsManager from "../../managers/productsManager/productsManager";
import FunctionHandler from "../../utils/functionHandler";
import Box from "@mui/material/Box";
import {useTranslation} from "react-i18next";

function Home() {
    const db = getDatabase(app);
    const [productsList, setProductsList] = useState([]);
    const [products, setProducts] = useState();
    const [carouselList, setCarouselList] = useState([]);
    const [imgLoaded, setImgLoaded] = useState(false);
    const {t} = useTranslation();

    useEffect(() => {
        const fetchData = async () => {
            const data = await ProductsManager.getProductsByIds(Object.keys(productsList));
            setProducts(data);
        };

        fetchData();
    }, [productsList]);

    useEffect(() => {
        const productsListRef = ref(db, '/homePageProducts');
        onValue(productsListRef, snapshot => setProductsList(snapshot.val()))
    }, [db]);

    useEffect(() => {
        const carouselRef = ref(db, '/homePageCarousel');
        onValue(carouselRef, snapshot => setCarouselList(snapshot.val()))
    }, [db]);

    const responsiveAd = {
        everyWhere: {
            breakpoint: {max: 4000, min: 0},
            items: 1
        }
    };

    const responsiveProducts = {
        desktop: {
            breakpoint: {max: 8000, min: 1024},
            items: 3.5,
        },
        tablet: {
            breakpoint: {max: 1024, min: 464},
            items: 2,
        },
        mobile: {
            breakpoint: {max: 464, min: 0},
            items: 1.5,
        }
    };

    return (
        <Container maxWidth="md" sx={{px: {xs: 0}}}>
            <CardContent sx={{mt: {xs: 2, md: 0}, mb: 3, px: {xs: 0}}}>
                {carouselList && <Box sx={{height: (imgLoaded ? 1 : '1px'), opacity: (imgLoaded ? 1 : 0)}}><Carousel
                    responsive={responsiveAd}
                    autoPlay={true}
                    autoPlaySpeed={5000}
                    swipeable
                    showDots
                    infinite
                    partialVisible={false}
                    pauseOnHover
                    rtl={false}
                    arrows
                    customLeftArrow={<LeftArrow/>}
                    customRightArrow={<RightArrow/>}
                    dotListClass="custom-dot-list-style"
                >
                    {carouselList.map((item, index) =>
                        <img key={item.src + index}
                             alt={t(item.alt)}
                             onLoad={() => setImgLoaded(true)}
                             style={{width: '100%'}}
                             src={FunctionHandler.getFunctionUrl(`/dep/${t(item.src)}`)}/>)}
                </Carousel></Box>}
                {!imgLoaded && <Box sx={{width:900, height: 450, background: '#f3f3f3', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <CircularProgress/>
                </Box>}
            </CardContent>

            {products && <Carousel
                responsive={responsiveProducts}
                swipeable
                partialVisible={false}
                customLeftArrow={<LeftArrow/>}
                customRightArrow={<RightArrow/>}
            >
                {Object.keys(productsList).filter(key => products[key]).map(key => <CardContent key={key} sx={{p: 0, m: 1, height: 350}} className={'laca'}>
                    <ProductCard product={products[key]}/>
                </CardContent>)}

            </Carousel>}
        </Container>
    );
}

export default Home;
